module.exports = __webpack_public_path__ + "static/media/partner.9661b3f2.svg";